import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.mjs',
    import.meta.url
).toString();

export default function PDFView({url}) {

    const [numPages, setNumPages] = useState(null);

    const onDocumentLoadSuccess = ({ numPages: nextNumPages }) => setNumPages(nextNumPages);
    const onDocumentLoadError = (err) => console.log(err);

    return (
        <div className="Example">
            <div className="Example__container">
                <div className="Example__container__document">
                    <Document
                        file={url}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={onDocumentLoadError}
                    >
                        {
                            Array.from(
                                new Array(numPages),
                                (el, index) => (
                                    <Page
                                        key={`page_${index + 1}`}
                                        pageNumber={index + 1}
                                        renderTextLayer
                                        renderAnnotationLayer={false}
                                    />
                                ),
                            )
                        }
                    </Document>
                </div>
            </div>
        </div>
    );
}
